import { normalizeHeader, SYNONYMS } from './fieldSynonyms';

const ALL_SYNONYMS = Object.values(SYNONYMS).flat();

function cellMatchesAnySynonym(cell) {
  const norm = normalizeHeader(cell);
  if (!norm) return false;
  return ALL_SYNONYMS.some((s) => norm === s || norm.includes(s) || s.includes(norm));
}

function scoreRow(row) {
  if (!Array.isArray(row)) return 0;
  return row.reduce((n, cell) => (cellMatchesAnySynonym(cell) ? n + 1 : n), 0);
}

function nonEmptyCount(row) {
  if (!Array.isArray(row)) return 0;
  return row.reduce((n, cell) => (cell != null && String(cell).trim() !== '' ? n + 1 : n), 0);
}

export function detectHeader(rawRows, { scanLimit = 15, dataScanAhead = 10 } = {}) {
  let bestIndex = 0;
  let bestScore = 0;
  const limit = Math.min(scanLimit, rawRows.length);
  for (let i = 0; i < limit; i += 1) {
    const score = scoreRow(rawRows[i]);
    if (score > bestScore) { bestScore = score; bestIndex = i; }
  }

  // First data-like row after the header: skip blanks and single-cell section/
  // group rows (< 2 non-empty cells) and any repeated header line.
  let dataStartRowIndex = bestIndex + 1;
  const end = Math.min(bestIndex + 1 + dataScanAhead, rawRows.length);
  for (let i = bestIndex + 1; i < end; i += 1) {
    if (nonEmptyCount(rawRows[i]) < 2) continue;
    if (bestScore > 0 && scoreRow(rawRows[i]) >= bestScore * 0.6) continue;
    dataStartRowIndex = i;
    break;
  }
  return { headerRowIndex: bestIndex, dataStartRowIndex };
}
